import { render, staticRenderFns } from "./CercaPreventivi.vue?vue&type=template&id=08843cb4&scoped=true&"
import script from "./CercaPreventivi.vue?vue&type=script&lang=js&"
export * from "./CercaPreventivi.vue?vue&type=script&lang=js&"
import style0 from "../../../assets/css/preventivi/dialog/cercaPreventivi.css?vue&type=style&index=0&id=08843cb4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08843cb4",
  null
  
)

export default component.exports